import { colors } from "../utils";

export const initialSegmentNode =
  '{"ROOT":{"type":{"resolvedName":"EmptyContainerWidget"},"isCanvas":true,"props":{"data-cy":"root-container"},"displayName":"EmptyContainer","custom":{},"hidden":false,"nodes":[],"linkedNodes":{}}}';

export const newSegment = ({
  id,
  currentPos,
  color,
  newSegmentValue,
  ...rest
}) => {
  return {
    id,
    position: currentPos,
    // title: `Segment ${id}`,
    value: newSegmentValue,
    data_value: 1,
    selected: true,
    is_locked: false,
    resize_lock: false,
    initialNode: initialSegmentNode,
    is_modified: true,
    settings: {
      wallpaperTransparency: 100,
      wallpaperResizing: 20,
      wallpaperOverlayColor: "#ffffff",
      bgWallpaper: "",
      isPattern: false,
      title: `Segment ${id}`,
      color,
      icon: "",
      segmentBgColor: "#ffffff",
      currentBg: 0,
    },
    selectedPalette: null,
    suggestedColors: [],
    nodes:
      '{"ROOT":{"type":{"resolvedName":"EmptyContainerWidget"},"isCanvas":true,"props":{"data-cy":"root-container"},"displayName":"EmptyContainer","custom":{},"hidden":false,"nodes":[],"linkedNodes":{}}}',
    ...rest,
  };
};
